import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { salesDistributionAPI, companyAPI, masterDataAPI } from '../services/api';

const Dashboard = () => {
  const [stats, setStats] = useState({
    salesOrgs: 0,
    companies: 0,
    languages: 0,
    divisions: 0,
    distChannels: 0,
    countries: 0,
    currencies: 0,
  });

  const [recentActivity] = useState([
    { type: 'create', title: 'Chicago Distribution Center', user: 'Tom Anderson', date: '11/3/2024' },
    { type: 'create', title: 'APAC Sales', user: 'John Doe', date: '11/3/2024' },
    { type: 'assign', title: 'Direct Sales → North America Sales', user: 'Jane Smith', date: '11/3/2024' },
    { type: 'edit', title: 'Chicago Manufacturing Plant', user: 'Mike Johnson', date: '11/3/2024' },
    { type: 'create', title: 'US Operations Center', user: 'Sarah Johnson', date: '11/2/2024' },
  ]);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const [salesOrgs, companies, languages, divisions, distChannels, countries, currencies] = await Promise.all([
        salesDistributionAPI.getSalesOrganizations(),
        companyAPI.getCompanies(),
        masterDataAPI.getLanguages(),
        salesDistributionAPI.getDivisions(),
        salesDistributionAPI.getDistributionChannels(),
        masterDataAPI.getCountries(),
        masterDataAPI.getCurrencies(),
      ]);
      setStats({
        salesOrgs: salesOrgs.data.length,
        companies: companies.data.length,
        languages: languages.data.length,
        divisions: divisions.data.length,
        distChannels: distChannels.data.length,
        countries: countries.data.length,
        currencies: currencies.data.length,
      });
    } catch (error) {
      console.error('Error loading stats:', error);
    }
  };

  const ModuleSection = ({ title, badge, badgeColor, borderColor, items }) => (
    <div className={`bg-white rounded-lg border-l-4 ${borderColor} p-4 hover:shadow-md transition-shadow`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
          <span className={`px-2 py-0.5 text-xs font-semibold rounded ${badgeColor}`}>
            {badge}
          </span>
        </div>
      </div>
      <div className="space-y-2">
        {items.map((item, idx) => (
          <div key={idx} className="flex items-center justify-between group cursor-pointer">
            <span className="text-sm text-gray-600 group-hover:text-gray-900">{item.label}</span>
            <span className="text-sm font-semibold text-gray-900">{item.count}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <Layout>
      <div className="p-6 max-w-7xl mx-auto" data-testid="dashboard-page">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
          <p className="text-sm text-gray-500 mt-1">Sales & Distribution Module Overview</p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-3 gap-4 mb-6">
          <div className="bg-white rounded-lg p-4 border border-gray-200">
            <div className="text-2xl font-bold text-gray-900">{stats.companies + stats.salesOrgs + stats.languages + stats.divisions + stats.distChannels + stats.countries + stats.currencies}</div>
            <div className="text-xs text-gray-500 mt-1">Total Entities</div>
          </div>
          <div className="bg-white rounded-lg p-4 border border-gray-200">
            <div className="text-2xl font-bold text-gray-900">{stats.salesOrgs + stats.divisions + stats.distChannels}</div>
            <div className="text-xs text-gray-500 mt-1">Sales & Distribution Entities</div>
          </div>
          <div className="bg-white rounded-lg p-4 border border-gray-200">
            <div className="text-2xl font-bold text-gray-900">{stats.languages + stats.countries + stats.currencies}</div>
            <div className="text-xs text-gray-500 mt-1">Master Data Records</div>
          </div>
        </div>

        {/* Module Sections Grid */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          <ModuleSection
            title="Sales & Distribution"
            badge="SD"
            badgeColor="bg-orange-100 text-orange-700"
            borderColor="border-orange-500"
            items={[
              { label: 'Sales Organizations', count: stats.salesOrgs },
              { label: 'Distribution Channels', count: stats.distChannels },
              { label: 'Divisions', count: stats.divisions },
            ]}
          />

          <ModuleSection
            title="Master Data"
            badge="MD"
            badgeColor="bg-orange-100 text-orange-700"
            borderColor="border-orange-500"
            items={[
              { label: 'Languages', count: stats.languages },
              { label: 'Countries', count: stats.countries },
              { label: 'Currencies', count: stats.currencies },
            ]}
          />

          <ModuleSection
            title="Company Management"
            badge="CO"
            badgeColor="bg-orange-100 text-orange-700"
            borderColor="border-orange-500"
            items={[
              { label: 'Companies', count: stats.companies },
              { label: 'Company Codes', count: stats.companies },
            ]}
          />
        </div>

      </div>
    </Layout>
  );
};

export default Dashboard;
